/******************************************************
 *                  Global exploitation Ctrl
 ********************************************************/

"use strict";


angular.module("exploitation").controller("MapMatchingRoutesCtrl", [
	"$scope", "$http", "$location", "$routeParams", "ExploitationService", "MapService", "CONSTANTS", "OkinaLeafletService", "ENV", "toastr", "Utils", "$uibModal",
	function ($scope, $http, $location, $routeParams, ExploitationService, MapService, CONSTANTS, OkinaLeafletService, ENV, toastr, Utils, $uibModal) {

	var POINT_INTERMEDIAIRE = "Point intermédiaire";

	var firstRoutesFounded = false;
	var routingControl, exchangeModal;

    $scope.LeafletService = OkinaLeafletService;

	$scope.profilesList = [
		{label: "Bus", profile: "bus"},
		{label: "Coach", profile: "bus"},
		{label: "Voiture", profile: "driving"},
		{label: "Tram", profile: "tram"},
		{label: "Rail", profile: "rail"},
		{label: "Air", profile: "air"},
		{label: "Funicular", profile: "air"},
		{label: "Ferry", profile: "ferry"},
		{label: "Water", profile: "ferry"},
		{label: "Metro", profile: "metro"},
		{label: "Cableway", profile: "cableway"},
		{label: "TrolleyBus", profile: "trolleyBus"}
	];


	$scope.data = {
		waypoints: [],
		originalWaypoints: [],
		modificationMap: false,
		currentRouteData: {
			stop_points: []
		},
		profileChoosed : $scope.profilesList[0],
		canSaveData : false
	};





	// Pagination
	$scope.pagination = {
		currentPage: 1,
		itemsPerPage: 5,
		totalItems: $scope.data.waypoints.size
	};

	$scope.setPagingData = function () {
		$scope.data.waypointsFilter = $scope.data.waypoints.slice(
			($scope.pagination.currentPage - 1) * $scope.pagination.itemsPerPage,
			$scope.pagination.currentPage * $scope.pagination.itemsPerPage
		);
	};

	$scope.openExchangeModal = function (positionWaypointsFilter) {
		$scope.modal = {
			positions: [],
		    turnBack: false
        };
		for (var i = 0; i < $scope.data.waypoints.length; i++) {
			$scope.modal.positions.push({
				label: "#" + (i + 1),
				value: i
			});
		}
		$scope.modal.positions.splice(0, 1);
		$scope.modal.positions.splice($scope.modal.positions.length - 1, 1);
		$scope.modal.position = $scope.modal.positions[positionWaypointsFilter + ($scope.pagination.itemsPerPage * ($scope.pagination.currentPage - 1)) - 1];
		$scope.modal.originalPosition = $scope.modal.position;
		$scope.setPagingData();
		exchangeModal = Utils.openModal($uibModal, "exchangeModal.html", $scope);
	};

	$scope.exchange = function (fromIndex, toIndex) {
		const element = $scope.data.waypoints[fromIndex];
		$scope.data.waypoints.splice(fromIndex, 1);
		$scope.data.waypoints.splice(toIndex, 0, element);
		reloadMap();
		exchangeModal.close();
	};

    $scope.toggleTurnback = (waypoint) => {
        waypoint.turnBack = !waypoint.turnBack;
        reloadMap();
    };

    function initMap() {
        OkinaLeafletService.reset();
        OkinaLeafletService.init("map");
        OkinaLeafletService.setCenter(MapService.DEFAULT_CENTER);
    }

	/**
	 * Restful navigation.
	 */
	initMap();
    if ($routeParams.routeId) {
		ExploitationService.getRoute($routeParams.routeId).then((response) => {
			const stopPointsData = response.data;
			$scope.data.currentRouteData = stopPointsData;
			$scope.data.profileChoosed = $scope.profilesList.find(profile => profile.label === stopPointsData.transportModeName);
			convertWaypoint();
		});
	}

	$scope.goReturn = function () {
		if ( $routeParams.hasOwnProperty( "urlBack") ) {
			var path = "e-iti/" + $routeParams.urlBack + "/" + $routeParams.routeId;
			if ( $routeParams.hasOwnProperty( "jpBack") ) {
				path = path + "/" + $routeParams.jpBack;
			}
			$location.path( path);
		} else {
			$location.path("e-iti/itineraires/" + $routeParams.routeId);
		}
	};

	function findStopPointId(positionInWaypoints) {
		// Si c'est un point intermédiaire, pas de findStopPointid
		if (!$scope.isStopAreaPoint($scope.data.waypoints[positionInWaypoints])) {
			return;
		}

		// On connait la position dans le waypoints, on cherche maintenant à compter le nombre de points intermédiaires pour savoir la position dans le currentRouteData
		var countIntermediatePoints = 0;
		for (var i = 0; i < positionInWaypoints; i++) {
			var stopPoint = $scope.data.waypoints[i];
			if (!$scope.isStopAreaPoint(stopPoint)) {
				countIntermediatePoints++;
			}
		}
		return $scope.data.currentRouteData.stop_points[positionInWaypoints - countIntermediatePoints].stop_point_id;
	}

	/**
	 * Sauvegarder la map
	 */
    $scope.saveMapMatching = function () {
        var points = [];
        for (var i = 0; i < $scope.data.waypoints.length; i++) {
            var stopPoint = $scope.data.waypoints[i];
            points.push({
                lat: stopPoint.lat,
                lng: stopPoint.lng,
                okinaStopPointId: findStopPointId(i),
                turnBack: stopPoint.turnBack,
            });
        }

		ExploitationService.setMapMatchingRoute($routeParams.routeId, points)
			.then(() => {
				toastr.success("Tracé de l'itinéraire pris en compte");
				$scope.goReturn();
			})
			.catch(() => {
				toastr.error("Problème lors de l'enregistrement du tracé.");
			});
	};

    $scope.resetMap = function () {
        initMap();
        addMarkersSteps();
        loadMap();
    };

	/**
	 * Effacer le Map-matching
	 */
	$scope.resetMapMatching = function () {
		firstRoutesFounded = false;
        $scope.data.waypoints = angular.copy($scope.data.originalWaypoints);
		$scope.resetMap();
	};

	/**
	 * Supprimer un waypoint
	 * @param waypoint
	 */
	$scope.deletePoint = function (waypoint) {
		var index = $scope.data.waypoints.indexOf(waypoint);
		if (index > -1) {
			$scope.data.waypoints.splice(index, 1);
			reloadMap();
		}
	};

	$scope.isStopAreaPoint = function (waypoint) {
		return waypoint.name.indexOf(POINT_INTERMEDIAIRE) === -1;
	};

	$scope.getPositionWaypoint = function (index) {
		return (index + ($scope.pagination.itemsPerPage * ($scope.pagination.currentPage - 1))) + 1;
	};

    function convertWaypoint() {
        ExploitationService.getLatLngPointsMapMatching($routeParams.routeId)
            .then((response) => {
				const data = response.data;
                // On part des points par défaut
                for (var i = 0; i < $scope.data.currentRouteData.stop_points.length; i++) {
                    const stopPoint = $scope.data.currentRouteData.stop_points[i];
                    $scope.data.originalWaypoints.push(
                        {
                            lat: parseFloat(stopPoint.latitude),
                            lng: parseFloat(stopPoint.longitude),
                            name: stopPoint.commercial_name
                        }
                    );
                }

                if (data.length) {
                    $scope.data.waypoints = [];
                    $scope.data.mapMatchingPoints = data;
                    for (var i = 0; i < $scope.data.mapMatchingPoints.length; i++) {
                        const stopPoint = $scope.data.mapMatchingPoints[i];
                        $scope.data.waypoints.push({
                            lat: stopPoint.lat,
                            lng: stopPoint.lng,
                            name: stopPoint.okinaStopPoint !== null ? stopPoint.okinaStopPoint.commercial_name : POINT_INTERMEDIAIRE,
                            turnBack: stopPoint.turnBack,
                        });
                    }
                } else {
                    $scope.data.waypoints = angular.copy($scope.data.originalWaypoints);
                }

                addMarkersSteps();
                loadMap();
            }).catch(function (data) {
                console.log(data);
                toastr.error("Impossible de charger les points d'arrêt.");
                $scope.goReturn();
            });
    }

    function addMarkersSteps() {
        for (let i = 0; i < $scope.data.currentRouteData.stop_points.length; i++) {
            const stopPoint = $scope.data.currentRouteData.stop_points[i];
            OkinaLeafletService.createMarker({
                lat: parseFloat(stopPoint.latitude),
                lng: parseFloat(stopPoint.longitude),
                message: stopPoint.commercial_name,
                draggable: false,
                icon: {
                    type: "awesomeMarker",
                    icon: "bus",
                    prefix: "fa",
                    markerColor: "orange"
                }
            });
        }
    }

	function existName(list, name) {
		for (var i = 0; i < list.length; i++) {
			var stopPoint = list[i];
			if (stopPoint.name.indexOf(name) !== -1) {
				return true;
			}
		}
		return false;
	}

	function getStopPointNameLost() {
		for (var i = 0; i < $scope.data.currentRouteData.stop_points.length; i++) {
			var stopPoint = $scope.data.currentRouteData.stop_points[i];
			if (!existName($scope.data.waypoints, stopPoint.commercial_name)) {
				return stopPoint;
			}
		}
		return undefined;
	}

	/**
	 * Vérfier l'élément déplacé
	 */
	function checkUpdateWaypoints() {
		for (var i = 0; i < $scope.data.waypoints.length; i++) {
			var stopPoint = $scope.data.waypoints[i];
			if (stopPoint.name === "") {
				// Recherche si un nom de l'arrêt est manquant
				var pointLost = getStopPointNameLost();
				if (pointLost !== undefined) {
					stopPoint.name = pointLost.commercial_name;
				}
			}
			if (stopPoint.name === undefined || stopPoint.name === "") {
				stopPoint.name = POINT_INTERMEDIAIRE;
			}
		}
	}

    function loadMap() {
        const turnBackWaypoints = $scope.data.waypoints.filter(wp => wp.turnBack);

        const listWaypointsToQuery = [];

        if (turnBackWaypoints.length === 0) {
            listWaypointsToQuery.push(
                $scope.data.waypoints.map(w => w.lng + "," + w.lat)
            );
        } else {
            let i;
            let currentList = [];

            for (i = 0; i < $scope.data.waypoints.length; i++) {
                const currentWp = $scope.data.waypoints[i];

                currentList.push(currentWp);
                if (currentWp.turnBack === true) {
                    listWaypointsToQuery.push(
                        currentList.map(w => w.lng + "," + w.lat)
                    );
                    currentList = [];
                    currentList.push(currentWp);
                }
            }

            listWaypointsToQuery.push(
                currentList.map(w => w.lng + "," + w.lat)
            );
        }

        OkinaLeafletService.getMap().then(map => {
			let httpRequests = listWaypointsToQuery.map(wpList => {
				return $http.get(ENV.API_URL + "/osrm/route/v1/" + $scope.data.profileChoosed.profile + "/" + wpList.join(encodeURIComponent(";")), {
					params: {
						steps: true,
						alternatives: false,
						overview: "full",
						geometries: "geojson",
					}
				}).catch(() => {
					toastr.error("La route n'a pas pu être générée ou est vide.", "Problème lors du chargement");
					return null;
				});
			});

            Promise.all(httpRequests)
                .then(listORMCPaths => {
                    let nbStepsHandled = 0;
                    let listSteps = [];

                    listORMCPaths.forEach((path, index) => {
                        if (path.data.routes === undefined || path.data.routes.length === 0) {
                            console.error("Routes empty");
                        } else {
                            const currentRoute = path.data.routes[0];
                            for (let i = 0; i < currentRoute.legs.length; i++) {
                                const leg = currentRoute.legs[i];

                                listSteps.push({
                                    currentIndex: nbStepsHandled,
                                    geometry: {
                                        type: "LineString",
                                        coordinates: leg.steps
                                            .flatMap(s => s.geometry.coordinates)
                                    }
                                });

                                nbStepsHandled++;
                            }
                        }
                    });

                    listSteps.forEach(step => displayStepGeometryAndDraggableEvents(step, map));

                    for (let i = 0; i < $scope.data.waypoints.length; i++) {
                        const waypoint = $scope.data.waypoints[i];

                        OkinaLeafletService.createMarkerWithName("WP" + i, {
                            lat: waypoint.lat,
                            lng: waypoint.lng,
                            message: waypoint.name,
                            id: i,
                            draggable: true,
                            zIndexOffset: 1000,
                            icon: {
                                type: "extraMarker",
                                icon: "fa-number",
                                number: i + 1,
                                markerColor: "blue",
                            }
                        });

                        const marker = OkinaLeafletService.getMarkerWithName("WP" + i);
                        marker.on("dragend", e => {
                            const id = e.target.options.id;
                            const currentWp = $scope.data.waypoints[id];
                            currentWp.lat = e.target._latlng.lat;
                            currentWp.lng = e.target._latlng.lng;

                            reloadMap();
                        });
                    }

                    checkUpdateWaypoints();
                    $scope.setPagingData();
                    if (!firstRoutesFounded) {
                        OkinaLeafletService.zoomToVisibleElements();
                        firstRoutesFounded = true;
                        $scope.data.canSaveData = true;
                    }


                });
        });
    }

    function displayStepGeometryAndDraggableEvents(step, map) {
        OkinaLeafletService.addShapeGeoJson(step.geometry, {
            "color": "red",
            "weight": 4
        }, {
            id: step.currentIndex,
            onMouseDown: e => {

                const indexStep = e.target.options.properties.id;

                const idDraggedPoint = "currentlyDragged";
                OkinaLeafletService.createMarkerWithName(idDraggedPoint, {
                    lat: e.latlng.lat,
                    lng: e.latlng.lng,
                    icon: {
                        type: "extraMarker",
                        icon: "fa-number",
                        number: indexStep + 1,
                        markerColor: "blue",
                    },
                    draggable: true
                });

                const marker = OkinaLeafletService.getMarkerWithName(idDraggedPoint);
                const initialLatLng = e.latlng;

                const prevWp = $scope.data.waypoints[indexStep];
                const nextWp = $scope.data.waypoints[indexStep + 1];

                let line = null;


                const draggingEnabled = map.dragging.enabled();
                const mouseMove = L.bind(function (e) {
                    let latLngs;
                    if (marker) {
                        marker.setLatLng(e.latlng);
                    }

                    latLngs = line.getLatLngs();
                    latLngs.splice(1, 1, e.latlng);
                    line.setLatLngs(latLngs);

                    L.DomEvent.stop(e);
                });

                const mouseUp = L.bind(function (e) {
                    if (marker) {
                        OkinaLeafletService.deleteMarkerWithName(idDraggedPoint);
                    }

                    map.removeLayer(line);

                    map.off("mousemove", mouseMove);
                    map.off("mouseup", mouseUp);

                    addNewWaypointInSequence(
                        indexStep + 1,
                        {
                            lat: e.latlng.lat,
                            lng: e.latlng.lng,
                            name: POINT_INTERMEDIAIRE
                        }
                    );

                    if (draggingEnabled) {
                        map.dragging.enable();
                    }
                });


                line = new L.Polyline([[prevWp.lat, prevWp.lng], initialLatLng, [nextWp.lat, nextWp.lng]], {
                    color: "red",
                    opacity: 1,
                    weight: 2,
                    dashArray: "7,12"
                })
                    .addTo(map);

                if (draggingEnabled) {
                    map.dragging.disable();
                }

                map.on("mousemove", mouseMove);
                map.on("mouseup", mouseUp);
            }
        });
    }

    function reloadMap() {
        OkinaLeafletService.reset();

        addMarkersSteps();
        loadMap();
    }

    function addNewWaypointInSequence(index, newWaypoint) {
        $scope.data.waypoints.splice(index, 0, newWaypoint);

        reloadMap();
    }
}]);
